import { useCopies } from "shared/hooks/useCopies";
import { UserProfileService } from "../../types";

export default function UserRoles(props: { service: UserProfileService }) {
  const copies = useCopies();
  return (
    <div className="myProfile_wrapper">
      <span>{props.service.roles.length > 1 ? copies.get("roles") : copies.get("role")}</span>
      <div className="myProfile_roles">
        {props.service.roles.map(role => (
          <span className="myProfile_roles_item" key={role}>
            {role}
          </span>
        ))}
      </div>
    </div>
  );
}
